import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.css'; //引入全局的base文件
import store from './store'
import '@/style/index.scss' // global css

// 按需引入部分组件
import { Uploader, Button, Toast, Loading, Image, Dialog, Progress,Divider,ImagePreview, ActionSheet, DatetimePicker, Popup, Rate, Overlay, Picker } from 'vant';
import 'vant/lib/index.css';
Vue.use(Uploader).use(Button).use(Toast).use(Loading).use(Image).use(Dialog).use(Progress).use(Divider).use(ImagePreview).use(ActionSheet).use(DatetimePicker).use(Popup)
.use(Rate).use(Overlay).use(Picker);

Vue.config.productionTip = false


Vue.filter('dateFormat', (dataStr) => {
  var time = new Date(dataStr * 1000);
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str;
    }
    return str
  }
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js